import { Box } from '@quintoandar-tokko/jopijs';
import styles from './components.module.scss';

export default function WithoutCategoryTag({ text, className = '', ...props }) {
  const classNames = `${styles.withoutCategoryTag} ${className}`;

  return (
    <Box className={classNames} {...props}>
      {text}
    </Box>
  );
}
